import type { TSearchResultsItem } from 'App/Map/MapSearch/types'
import { PersistentStoreName } from 'stores/_utils/persistentStore/persistenceStoresCleanUpMap'
import { persistentInit } from 'stores/_utils/persistentStore/persistentStore'
import type { TPropertyId } from 'stores/fieldAssetStore/helperTypes'

export const mapSearchStore = persistentInit<{
  highlightedPropertyIds: Record<TPropertyId, true>
  previousSearches: TSearchResultsItem[]
}>({
  initialState: {
    highlightedPropertyIds: {},
    previousSearches: [],
  },
  keysToPutInPersistentStorage: {
    highlightedPropertyIds: true,
    previousSearches: true,
  },
  keysToPutInURL: {
    highlightedPropertyIds: false,
    previousSearches: false,
  },
  storeName: PersistentStoreName.MAP_SEARCH_STORE,
})
